const ARTICLE_TOC_SELECTOR = '.wp-block-rank-math-toc-block';

const getSectionWord = (count) => {
    if (count === 1) {
        return 'SEKCJA';
    }

    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
        return 'SEKCJE';
    }

    return 'SEKCJI';
};

const setArticleTocState = (toc, button, panel, expanded) => {
    toc.classList.toggle('is-open', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    panel.setAttribute('aria-hidden', String(!expanded));
    panel.toggleAttribute('inert', !expanded);
};

const buildArticleTocHeading = (label, count, panelId, headingTag = 'h2') => {
    const heading = document.createElement(headingTag);
    const button = document.createElement('button');
    const buttonLabel = document.createElement('span');
    const buttonMeta = document.createElement('span');
    const countLabel = document.createElement('span');
    const arrow = document.createElement('span');

    heading.className = 'ArticleToc__heading';
    button.className = 'Button Button--no-style ArticleToc__toggle';
    button.type = 'button';
    button.setAttribute('aria-controls', panelId);
    buttonLabel.className = 'ArticleToc__toggleLabel';
    buttonLabel.textContent = label || 'SPIS TREŚCI';
    buttonMeta.className = 'ArticleToc__toggleMeta';
    countLabel.textContent = `${count} ${getSectionWord(count)}`;
    arrow.className = 'ArticleToc__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '↓';

    buttonMeta.append(countLabel, arrow);
    button.append(buttonLabel, buttonMeta);
    heading.append(button);

    return { heading, button };
};

const bindArticleToc = (toc, index) => {
    if (toc.dataset.articleTocReady === 'true') {
        return;
    }

    const sourceHeading = toc.querySelector(':scope > h2, :scope > h3');
    const panel = toc.querySelector(':scope > nav') || toc.querySelector(':scope > ul');
    const list = panel?.matches('ul') ? panel : panel?.querySelector('ul');

    if (!panel || !list) {
        return;
    }

    toc.dataset.articleTocReady = 'true';
    toc.classList.add('ArticleToc');
    panel.classList.add('ArticleToc__panel');

    const panelId = panel.id || `article-toc-panel-${index + 1}`;
    const directItems = list.querySelectorAll(':scope > li');
    const sectionCount = directItems.length || list.querySelectorAll('li').length;
    const headingLabel = sourceHeading?.textContent.trim() || 'SPIS TREŚCI';
    const headingTag = sourceHeading?.tagName.toLowerCase() || 'h2';
    const { heading, button } = buildArticleTocHeading(
        headingLabel,
        sectionCount,
        panelId,
        headingTag,
    );

    panel.id = panelId;

    if (sourceHeading) {
        if (sourceHeading.id) {
            heading.id = sourceHeading.id;
        }
        sourceHeading.replaceWith(heading);
    } else {
        toc.prepend(heading);
    }

    button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        setArticleTocState(toc, button, panel, !expanded);
    });

    setArticleTocState(toc, button, panel, false);
};

document.querySelectorAll(ARTICLE_TOC_SELECTOR).forEach(bindArticleToc);
